
import AppPromo from "@/components/AppPromo";
import Footer from "@/components/Footer";
import Header from "@/components/HeaderUpdated";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { TooltipProvider } from "@/components/ui/tooltip";
import { supabase } from "@/integrations/supabase/client";
import { Category } from "@/types";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";

const defaultProductImage = "/lovable-uploads/60244da3-6deb-4628-b29a-c8e90866808e.png";

const CategoriesPage = () => {
  const { data: categories, isLoading, error } = useQuery({
    queryKey: ['categories-page'],
    queryFn: async () => {

      const { data, error } = await supabase
        .from('categories')
        .select('*')
        .is('parent_id', null)
        .order('name');

      if (error) {
        throw error;
      }

      return data as Category[] || [];
    }
  });

  // Log any query errors
  if (error) {
  }

  return (
    <TooltipProvider>
      <div className="min-h-screen flex flex-col bg-brand-darker text-white">
        <Header />
        <main className="flex-grow pt-32 pb-16">
          <section className="container mx-auto px-4">
            <h1 className="text-4xl md:text-5xl font-bold text-center mb-4">Categorias</h1>
            <p className="text-gray-400 text-center max-w-2xl mx-auto mb-16">
              Explore todas as categorias disponíveis de produtos DartsBeat Store
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
              {error ? (
                <div className="col-span-full text-center py-8">
                  <p className="text-red-400 mb-4">Erro ao carregar categorias</p>
                  <p className="text-gray-400 text-sm">{error.message}</p>
                </div>
              ) : isLoading ? (
                // Esqueletos de carregamento
                Array.from({ length: 8 }).map((_, index) => (
                  <div key={index} className="bg-brand-gray rounded-lg overflow-hidden">
                    <Skeleton className="h-48 bg-gray-700" />
                    <div className="p-4">
                      <Skeleton className="h-6 bg-gray-700 rounded w-3/4 mb-2" />
                      <Skeleton className="h-4 bg-gray-700 rounded w-1/2" />
                    </div>
                  </div>
                ))
              ) : categories && categories.length > 0 ? (
                categories.map((category) => {
                  return (
                    <div key={category.id} className="bg-brand-gray rounded-lg overflow-hidden group">
                      <div className="relative h-48 overflow-hidden">
                        <img
                          src={category.image || defaultProductImage}
                          alt={category.name}
                          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                          onError={(e) => {
                            const target = e.currentTarget as HTMLImageElement;
                            target.src = defaultProductImage;
                          }}
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
                      </div>
                      <div className="p-4">
                        <h3 className="font-bold text-xl mb-4">{category.name}</h3>
                        <Button asChild className="w-full bg-brand-red hover:bg-brand-red/90">
                          <Link to={`/shop?category=${category.id}`}>
                            Ver Produtos
                          </Link>
                        </Button>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="col-span-full text-center py-8">
                  <p className="text-gray-400">Nenhuma categoria encontrada.</p>
                </div>
              )}
            </div>
          </section>
          
          <div className="mt-16">
            <AppPromo />
          </div>
        </main>
        <Footer />
      </div>
    </TooltipProvider>
  );
};

export default CategoriesPage;
